import { API_BASE_URL } from "@src/config/constants";

export const logout = () => {
  return fetch(`${API_BASE_URL}/logout`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    credentials: "include",
  });
};
